import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Footer } from "../Footer";
import firstfellowpartnersWhitePng1 from "../../assets/images/first-fellow-partners-white.png";
import StaggeredMenu from "../ui/StaggeredMenu";
import { Label } from "../ui/label";
import { Checkbox } from "../animate-ui/components/radix/checkbox";
import unicornImage from "../../assets/images/unicorn-icon.png";
import bankruptIcon from "../../assets/images/bankrupt-icon.svg";

// Import existing logos that are still needed
import logoAlphasense from "../../assets/images/logos-legacy/alphasense.png";
import logoAiven from "../../assets/images/logos-legacy/aiven.png";
import logoAito from "../../assets/images/logos-legacy/aito.png";
import logoBandwidthX from "../../assets/images/logos-legacy/bandwidthx.png";
import logoCadentia from "../../assets/images/logos-legacy/cadentia.png";
import logoConeksion from "../../assets/images/logos-legacy/coneksion.png";

// New logos from the logos-primary folder
import logoCybexer from "../../assets/images/logos-primary/cybexer-rgb-logo-reversed-out-1.png";
import logoDetectify from "../../assets/images/logos-primary/detectify.png";
import logoDodreams from "../../assets/images/logos-primary/dodreams-cover.png";
import logoDonut from "../../assets/images/logos-primary/donut-lab.png";
import logoEfecte from "../../assets/images/logos-primary/efecte-logo.png";
import logoEkahau from "../../assets/images/logos-primary/ekahau-logo-heatbar-white@2x.png";
import logoEnevo from "../../assets/images/logos-primary/enevo-logo.png";
import logoEpassi from "../../assets/images/logos-primary/epassi-logo-materialbank-standard-1.png";
import logoFuturice from "../../assets/images/logos-primary/futurice-logo.png";
import logoGaladriel from "../../assets/images/logos-primary/galadriel.svg";
import logoHamina from "../../assets/images/logos-primary/hamina-logo.png";
import logoHeltti from "../../assets/images/logos-primary/heltti-logo-white-200mm-rgb.png";
import logoHoxhunt from "../../assets/images/logos-primary/hoxhunt-logo-new.png";
import logoInclus from "../../assets/images/logos-primary/inclus-logo-text-nobackground-valk.png";
import logoIntergrid from "../../assets/images/logos-primary/intergrid-logo.png";
import logoIxiray from "../../assets/images/logos-primary/ixiray.png";
import logoKickstarter from "../../assets/images/logos-primary/kickstarter.png";
import logoKiloHealth from "../../assets/images/logos-primary/kilo-health-logo921970466.png";
import logoLouhe from "../../assets/images/logos-primary/louhe-logo-black-1.png";
import logoLumiDB from "../../assets/images/logos-primary/lumidb.png";
import logoMeeshkan from "../../assets/images/logos-primary/meshkan-logo.png";
import logoMendor from "../../assets/images/logos-primary/mendor-logo.png";
import logoMicrotask from "../../assets/images/logos-primary/microtask-logo.png";
import logoPaebbl from "../../assets/images/logos-primary/paebbl-logo.png";
import logoQuestback from "../../assets/images/logos-primary/questback-logo.png";
import logoQuanscient from "../../assets/images/logos-primary/quanscient-taglinelogo-gradient-8-1.png";
import logoSprintAI from "../../assets/images/logos-primary/sprintai-logo.png";
import logoTivian from "../../assets/images/logos-primary/tivian-logo-charcoal-rgb.png";
import logoUpright from "../../assets/images/logos-primary/upright-project-logo.png";
import logoVerge from "../../assets/images/logos-primary/verge-logo.png";
import logoWolt from "../../assets/images/logos-primary/wolt-logo.png";
import logoWOT from "../../assets/images/logos-primary/wot-logo.png";
import logoThe280Company from "../../assets/images/logos-secondary/the280company.png";
import logoMVH from "../../assets/images/logos-secondary/mvh.png";
import logoFygy from "../../assets/images/logos-secondary/fygy.png";
import logoPicosun from "../../assets/images/logos-secondary/picosun.png";
import logoSmallGiant from "../../assets/images/logos-secondary/smallgiant.png";
import logoSmartcomLabs from "../../assets/images/logos-secondary/smartcomlabs.png";
import logoNimbleFox from "../../assets/images/logos-secondary/nimblefox.png";
import logoRecoil from "../../assets/images/logos-secondary/recoil.png";
import logoNomo from "../../assets/images/logos-secondary/nomo.png";
import logoMediverkko from "../../assets/images/logos-secondary/mediverkko.png";
import logoFuturefly from "../../assets/images/logos-secondary/futurefly.png";
import logoSeetheGood from "../../assets/images/logos-secondary/seethegood.png";
import logoElva from "../../assets/images/logos-secondary/elva.png";
import logoInven from "../../assets/images/logos-secondary/inven.png";
import logoTalentAdore from "../../assets/images/logos-secondary/talentadore.png";
import logoYAAK from "../../assets/images/logos-secondary/yaak.png";
import logoFinancekey from "../../assets/images/logos-secondary/financekey.png";
import logoControlDev from "../../assets/images/logos-secondary/controldev.png";
import logoBrandBastion from "../../assets/images/logos-secondary/brandbastion.png";
import logoFrosmo from "../../assets/images/logos-secondary/frosmo-logo.png";
import logoRens from "../../assets/images/logos-secondary/rens-logo.png";
import logoVuoAI from "../../assets/images/logos-secondary/vuoai-logo.png";
import logoEsox from "../../assets/images/logos-primary/esox-logo.svg";
import logoCybretAI from "../../assets/images/logos-primary/cybret-logo.png";
import logoEndform from "../../assets/images/logos-primary/endform-logo.svg";
import companiesData from "../../companies.json";
import { SEOHead } from "../SEOHead";

export const FamilyMembersPage = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [imageError, setImageError] = useState(false);
  
  const normalizeName = (name) => (name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  
  const nameToLogo = {
    // Updated logos with new logo files
    alphasense: logoAlphasense,
    aiven: logoAiven,
    aito: logoAito,
    bandwidthx: logoBandwidthX,
    cadentia: logoCadentia,
    coneksion: logoConeksion,
    cybexer: logoCybexer,
    cybexertechnologies: logoCybexer,
    detectify: logoDetectify,
    dodreams: logoDodreams,
    donut: logoDonut,
    efecte: logoEfecte,
    ekahau: logoEkahau,
    enevo: logoEnevo,
    epassi: logoEpassi,
    futurice: logoFuturice,
    galadriel: logoGaladriel,
    hamina: logoHamina,
    heltti: logoHeltti,
    hoxhunt: logoHoxhunt,
    inclus: logoInclus,
    intergrid: logoIntergrid,
    ixi: logoIxiray,
    ixira: logoIxiray,
    kickstarter: logoKickstarter,
    kilohealth: logoKiloHealth,
    louhe: logoLouhe,
    lumidb: logoLumiDB,
    meeshkan: logoMeeshkan,
    mendor: logoMendor,
    microtask: logoMicrotask,
    paebbl: logoPaebbl,
    questback: logoQuestback,
    quanscient: logoQuanscient,
    sprintai: logoSprintAI,
    tivian: logoTivian,
    theuprightproject: logoUpright,
    uprightproject: logoUpright,
    upright: logoUpright,
    verge: logoVerge,
    wolt: logoWolt,
    wot: logoWOT,
    the280company: logoThe280Company,
    mvh: logoMVH,
    fygy: logoFygy,
    picosun: logoPicosun,
    smallgiant: logoSmallGiant,
    smallgiantgames: logoSmallGiant,
    smartcomlabs: logoSmartcomLabs,
    nimblefox: logoNimbleFox,
    recoil: logoRecoil,
    nomo: logoNomo,
    mediverkko: logoMediverkko,
    futurefly: logoFuturefly,
    seethegood: logoSeetheGood,
    elva: logoElva,
    inven: logoInven,
    talentadore: logoTalentAdore,
    yaak: logoYAAK,
    financekey: logoFinancekey,
    controldev: logoControlDev,
    brandbastion: logoBrandBastion,
    frosmo: logoFrosmo,
    rens: logoRens,
    vuoai: logoVuoAI,
    vuo: logoVuoAI,
    esox: logoEsox,
    cybretai: logoCybretAI,
    cybret: logoCybretAI,
    endform: logoEndform,
  };
  
  const menuItems = [
    { label: 'Our Manifesto', ariaLabel: 'View our manifesto', link: '/manifesto' },
    { label: 'Family Members', ariaLabel: 'View family members', link: '/family' },
    { label: 'Team', ariaLabel: 'Meet our team', link: '/team' },
    { label: 'References', ariaLabel: 'View references', link: '/references' },
    { label: 'Get in touch', ariaLabel: 'Get in touch with us', link: '/contact' }
  ];

  const socialItems = [
    { label: 'Twitter', link: 'https://twitter.com' },
    { label: 'LinkedIn', link: 'https://linkedin.com' }
  ];

  // Filters - load from localStorage or use defaults
  const [showCurrent, setShowCurrent] = useState(() => {
    const saved = localStorage.getItem('familyFilters_showCurrent');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [showExited, setShowExited] = useState(() => {
    const saved = localStorage.getItem('familyFilters_showExited');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [showBankrupt, setShowBankrupt] = useState(() => {
    const saved = localStorage.getItem('familyFilters_showBankrupt');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  // Save filter state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('familyFilters_showCurrent', JSON.stringify(showCurrent));
  }, [showCurrent]);

  useEffect(() => {
    localStorage.setItem('familyFilters_showExited', JSON.stringify(showExited));
  }, [showExited]);

  useEffect(() => {
    localStorage.setItem('familyFilters_showBankrupt', JSON.stringify(showBankrupt));
  }, [showBankrupt]);

  const handleMemberClick = (member) => {
    setSelectedMember(member);
    setShowPopup(true);
    setImageError(false);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedMember(null);
  };

  // Transform companies data for display and sort alphabetically
  const baseMembers = companiesData
    .map((company, index) => ({
      id: index + 1,
      name: company.name,
      description: company.description,
      founded: company.founded.toString(),
      investment: company.ffp_investment,
      acquisition: company.exit_info,
      website: company.website,
      status: company.status,
      isUnicorn: company.is_unicorn,
      textOnlyLogo: company.text_only_logo === true
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  // Filter by checkboxes: exited if has acquisition (exit_info), bankrupt if status is "Bankrupt", current otherwise
  const familyMembers = baseMembers.filter(m => {
    const isExited = !!m.acquisition; // Only true if exit_info is not null and not empty
    const isBankrupt = m.status === "Bankrupt";
    const isCurrent = !isExited && !isBankrupt;
    
    // If exited filter is selected, only show companies with exit_info (not null)
    if (showCurrent && showExited && showBankrupt) return true;
    if (showCurrent && showExited && !showBankrupt) {
      // Show current companies OR bankrupt companies that have exit_info
      return !isBankrupt || (isBankrupt && isExited);
    }
    if (showCurrent && !showExited && showBankrupt) return !isExited;
    if (showCurrent && !showExited && !showBankrupt) return isCurrent;
    if (!showCurrent && showExited && showBankrupt) {
      // Show companies that are both exited and bankrupt, OR just exited (not bankrupt)
      // Note: Don't show bankrupt companies without exit_info when exited is selected
      return (isExited && isBankrupt) || (isExited && !isBankrupt);
    }
    if (!showCurrent && showExited && !showBankrupt) {
      // Only show exited companies (must have exit_info)
      return isExited;
    }
    if (!showCurrent && !showExited && showBankrupt) {
      // Only show bankrupt companies without exit_info
      return isBankrupt && !isExited;
    }
    return false;
  });

  return (
    <div className="bg-[#121212] w-full min-h-screen overflow-y-auto scrollbar-default flex flex-col items-center">
      <SEOHead
        title="Family Members | First Fellow Partners"
        description="Explore our portfolio of 50+ technology companies — from early-stage startups to unicorns like Wolt, Alphasense, and Aiven. See our current investments, exits, and success stories."
        path="/family"
      />
      {/* Navbar */}
        <div className="w-full bg-[#121212] border-b border-[#424242] z-50">
          <div className="flex justify-between items-center px-4 sm:px-6 lg:px-10 py-2 sm:py-4 gap-4">
            {/* Logo on the left */}
            <Link to="/" className="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] lg:w-[140px] lg:h-[140px]">
              <img
                className="w-full h-full object-contain"
                alt="First Fellow Partners logo"
                src={firstfellowpartnersWhitePng1}
              />
            </Link>

            {/* Mobile Filter Button - show only on mobile */}
            <div className="sm:hidden">
              <button
                onClick={() => setShowMobileFilters(!showMobileFilters)}
                className="flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg border border-white/20 text-white text-sm hover:bg-white/20 transition-colors"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7H21M9 12H21M17 17H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Filter
              </button>
            </div>

            {/* StaggeredMenu button on the right */}
            <div className="flex items-center gap-2 sm:gap-4">
              {/* Three checkboxes to the left - hide on small screens */}
              <div className="hidden sm:flex items-center gap-2 sm:gap-4">
                <Label className="flex items-center gap-x-1 sm:gap-x-2 cursor-pointer select-none text-sm sm:text-base lg:text-[18px]">
                  <Checkbox
                    size="sm"
                    variant="outline"
                    aria-label="Filter current"
                    checked={showCurrent}
                    onCheckedChange={setShowCurrent}
                  />
                  <span className="text-white/80">Current</span>
                </Label>
                <Label className="flex items-center gap-x-1 sm:gap-x-2 cursor-pointer select-none text-sm sm:text-base lg:text-[18px]">
                  <Checkbox
                    size="sm"
                    variant="outline"
                    aria-label="Filter exited"
                    checked={showExited}
                    onCheckedChange={setShowExited}
                  />
                  <span className="text-white/80">Exited</span>
                </Label>
                <Label className="flex items-center gap-x-1 sm:gap-x-2 cursor-pointer select-none text-sm sm:text-base lg:text-[18px]">
                  <Checkbox
                    size="sm"
                    variant="outline"
                    aria-label="Filter bankrupt"
                    checked={showBankrupt}
                    onCheckedChange={setShowBankrupt}
                  />
                  <span className="text-white/80">Bankrupt</span>
                </Label>
              </div>

              {/* Menu button on the right with responsive sizing */}
              <div className="w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] lg:w-[120px] lg:h-[120px] flex items-center justify-end">
                <StaggeredMenu
                position="right"
                items={menuItems}
                socialItems={socialItems}
                displaySocials={true}
                displayItemNumbering={true}
                menuButtonColor="#fff"
                openMenuButtonColor="#000"
                changeMenuColorOnOpen={true}
                colors={['#1a1a1a', '#424242']}
                logoUrl=""
                accentColor="#000"
                isFixed={true}
                onMenuOpen={() => console.log('Menu opened')}
                onMenuClose={() => console.log('Menu closed')}
                />
              </div>
            </div>
          </div>
        </div>


      {/* Mobile Filter Dropdown */}
      {showMobileFilters && (
        <div className="sm:hidden w-full bg-[#121212] border-b border-[#424242] px-4 py-4">
          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <span className="text-white text-lg font-medium">Filter</span>
              <button
                onClick={() => setShowMobileFilters(false)}
                className="text-white/60 hover:text-white transition-colors"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="flex flex-col gap-3">
              <Label className="flex items-center gap-x-3 cursor-pointer select-none text-base">
                <Checkbox
                  size="sm"
                  variant="outline"
                  aria-label="Filter current"
                  checked={showCurrent}
                  onCheckedChange={setShowCurrent}
                />
                <span className="text-white/80">Current Companies</span>
              </Label>
              <Label className="flex items-center gap-x-3 cursor-pointer select-none text-base">
                <Checkbox
                  size="sm"
                  variant="outline"
                  aria-label="Filter exited"
                  checked={showExited}
                  onCheckedChange={setShowExited}
                />
                <span className="text-white/80">Exited Companies</span>
              </Label>
              <Label className="flex items-center gap-x-3 cursor-pointer select-none text-base">
                <Checkbox
                  size="sm"
                  variant="outline"
                  aria-label="Filter bankrupt"
                  checked={showBankrupt}
                  onCheckedChange={setShowBankrupt}
                />
                <span className="text-white/80">Bankrupt Companies</span>
              </Label>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main className="flex flex-col items-center px-4 sm:px-6 lg:px-10 py-0 mt-0 mb-[20px] sm:mb-[40px] relative w-full">
        {/* Family Members Grid */}
        <div className="w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-0 border-l border-[#424242]">
          {familyMembers.map((member, index) => {
            // Calculate if this is in the first row based on screen size
            const isFirstRow = index < 2; // 2 per row on mobile
            // Calculate if this is the leftmost item based on screen size
            const isLeftmost = index % 2 === 0; // 2 per row on mobile
            
            return (
              <div 
                key={member.id} 
                className={`group aspect-square flex items-center justify-center p-4 sm:p-6 lg:p-8
                  ${isFirstRow ? 'border-t-0 lg:border-t-0' : 'border-t lg:border-t'}
                  ${isLeftmost ? 'border-l-0 lg:border-l-0' : 'border-l lg:border-l'}
                  border-r border-b border-[#424242]
                  cursor-pointer hover:bg-white/5 transition-colors
                `}
                onClick={() => handleMemberClick(member)}
              >
                <div className="flex items-center justify-center w-full h-full">
                  <span className="text-white text-sm sm:text-lg lg:text-2xl font-medium text-center">
                    {member.name}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </main>

      {/* Footer */}
      <div className="w-full">
        <Footer />
      </div>

      {/* Member Popup */}
      {showPopup && selectedMember && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/70 backdrop-blur-sm z-50 p-2 sm:p-4 animate-fade-in">
          <div className="max-w-2xl w-full max-h-[90vh] overflow-y-auto animate-fade-up">
            <div className="w-full bg-white/10 rounded-3xl border border-white/50 shadow-2xl p-4 sm:p-6 flex flex-col gap-4">
            {/* Header with close button */}
            <div className="flex flex-row justify-between items-center gap-4">
              <div className="flex items-center gap-4">
                {selectedMember.textOnlyLogo || !nameToLogo[normalizeName(selectedMember.name)] || imageError ? (
                  <span className="text-white text-2xl sm:text-3xl lg:text-4xl font-medium">
                    {selectedMember.name}
                  </span>
                ) : (
                  <img 
                    src={nameToLogo[normalizeName(selectedMember.name)]}
                    alt={selectedMember.name}
                    className="h-[60px] sm:h-[80px] w-auto object-contain filter brightness-150 contrast-125"
                    onError={() => setImageError(true)}
                  />
                )}
                {selectedMember.isUnicorn && (
                  <img 
                    src={unicornImage} 
                    alt="Unicorn" 
                    className="w-12 h-12 sm:w-16 sm:h-16 object-contain scale-x-[-1]"
                  />
                )}
              </div>
              <button 
                className="cursor-pointer hover:opacity-80 transition-opacity p-2 flex-shrink-0"
                onClick={closePopup}
                aria-label="Close popup"
              >
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.6666 13.3333L13.3333 26.6666M26.6659 26.6667L13.3326 13.3334" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
            {/* Company description */}
            <div className="text-white text-lg sm:text-xl lg:text-2xl font-light leading-relaxed mb-3">
              {selectedMember.description || "Company description"}
            </div>
            
            {/* Company details - compact list */}
            <div className="space-y-1">
              {/* Founded */}
              <div className="flex items-center gap-2">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.2518 12.49C16.9678 14.855 15.4188 15.8 14.7498 16.486C14.0798 17.174 14.1998 17.311 14.2448 18.32C14.2523 18.4448 14.2342 18.5699 14.1915 18.6875C14.1488 18.805 14.0825 18.9126 13.9967 19.0036C13.9109 19.0946 13.8074 19.167 13.6925 19.2164C13.5776 19.2659 13.4538 19.2912 13.3288 19.291H10.6708C10.5458 19.2908 10.4222 19.2651 10.3074 19.2155C10.1927 19.1659 10.0893 19.0934 10.0035 19.0027C9.9177 18.912 9.8513 18.8046 9.8084 18.6873C9.7655 18.57 9.7468 18.4452 9.7538 18.32C9.7538 17.33 9.8458 17.1 9.2498 16.486C8.4898 15.726 6.7018 14.653 6.7018 11.702C6.6972 10.969 6.8445 10.243 7.1345 9.5698C7.4244 8.8965 7.8507 8.2907 8.3864 7.7903C8.9221 7.29 9.5557 6.9061 10.2472 6.6628C10.9386 6.4195 11.673 6.3221 12.404 6.3767C13.1349 6.4313 13.8466 6.6367 14.4943 6.9801C15.142 7.3235 15.7115 7.7972 16.1669 8.3715C16.6223 8.9458 16.9539 9.6083 17.1406 10.3171C17.3273 11.026 17.3652 11.7659 17.2518 12.49Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10.4599 19.236V20.748C10.4599 21.161 10.6898 21.5 10.9729 21.5H13.0271C13.3109 21.5 13.5398 21.16 13.5398 20.748V19.236M11.2198 8.696C10.6294 8.6965 10.0632 8.931 9.6458 9.3486C9.2283 9.7662 8.9938 10.3325 8.9938 10.923M19.3319 11.904H21.1658M17.4859 5.892L18.7868 4.591M18.4859 17L19.7868 18.3M15.9998 2.377V3.86M5.2398 3.928L6.5318 4.62M2.4398 8.245L3.1315 7.5533M2.7785 7.624H2.2228" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="text-white text-base sm:text-lg lg:text-xl font-light">
                  <span className="font-semibold">Founded:</span> {selectedMember.founded || "N/A"}
                </span>
              </div>
              
              {/* Investment */}
              <div className="flex items-center gap-2">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.0001 11.2947C12.2841 1.4466 18.8636 1.333 21.4929 2.5073C22.6671 5.1365 22.5536 11.7161 12.7054 17C12.6032 16.4129 12.0353 14.875 10.5803 13.42C9.1253 11.965 7.5872 11.397 7.0001 11.2947Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14.0001 16.8C16.0427 17.7335 16.2608 19.4069 16.5438 21C16.5438 21 20.8222 18.0482 18.0855 14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7.2 10C6.2667 7.9571 4.5931 7.739 3 7.456C3 7.456 5.9519 3.1776 10 5.9143" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6.2085 14C5.5766 14.6317 4.5024 16.4642 5.2607 18.739C7.5355 19.4973 9.368 18.4231 10 17.7912" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M18.0953 7.753C18.0953 6.7328 17.2683 5.9058 16.2481 5.9058C15.2279 5.9058 14.4009 6.7328 14.4009 7.753C14.4009 8.7732 15.2279 9.6002 16.2481 9.6002C17.2683 9.6002 18.0953 8.7732 18.0953 7.753Z" stroke="white" strokeWidth="1.5"/>
                </svg>
                <span className="text-white text-base sm:text-lg lg:text-xl font-light">
                  {selectedMember.investment}
                </span>
              </div>
              
              {/* Exit/Acquisition info - show for exited companies with acquisition info */}
              {selectedMember.acquisition && selectedMember.status === 'Exited' && (
                <div className="flex items-center gap-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.9427 16.8354C20.2864 12.8866 18.2432 9.9461 16.467 8.2189C15.9501 7.7164 15.6917 7.4651 15.1208 7.2326C14.5499 7 14.0592 7 12.7828 7H10.9172C9.6408 7 9.4499 7 8.8793 7.2326C8.3087 7.4651 7.5499 7.7164 7.0331 8.2189C5.7568 9.9461 3.7136 12.8866 3.0573 16.8354C2.5689 19.7734 5.2793 22 8.3087 22H15.6913C18.7207 22 21.4311 19.7734 20.9427 16.8354Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7.2567 4.4429C7.0504 4.1426 6.7514 3.735 7.3691 3.6421C8.0041 3.5465 8.6633 3.9812 9.3087 3.9722C9.8925 3.9641 10.19 3.7052 10.509 3.3355C10.845 2.9462 11.3653 2 12.0002 2C12.635 2 13.1552 2.9462 13.4912 3.3355C13.8103 3.7052 14.1077 3.9641 14.6915 3.9722C15.3369 3.9812 15.9961 3.5465 16.6311 3.6421C17.2488 3.735 16.9498 4.1426 16.7435 4.4429L16.3106 5.3007C15.9116 5.8815 15.7121 6.1719 15.2945 6.336C14.877 6.5 14.3374 6.5 13.2583 6.5H11.7417C10.6626 6.5 10.123 6.5 9.7055 6.336C9.2879 6.1719 9.0884 5.8815 8.6894 5.3007L7.2567 4.4429Z" stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
                    <path d="M13.6266 12.9186C13.4104 12.1205 12.31 11.4003 10.9891 11.9391C9.6682 12.4778 9.4583 14.2113 11.4564 14.3955C12.3594 14.4787 12.9481 14.2989 13.4872 14.8076C14.0263 15.3162 14.1264 16.7308 12.7483 17.112C11.3703 17.4932 10.0059 16.8976 9.8573 16.0517M11.8416 10.9927V11.7531M11.8416 17.2293V17.9927" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span className="text-white text-base sm:text-lg lg:text-xl font-light">
                    {selectedMember.acquisition}
                  </span>
                </div>
              )}

              {/* Bankruptcy info - show for all bankrupt companies */}
              {selectedMember.status === 'Bankrupt' && (
                <div className="flex items-center gap-2">
                  <img 
                    src={bankruptIcon} 
                    alt="Bankrupt" 
                    className="w-6 h-6"
                  />
                  <span className="text-white text-base sm:text-lg lg:text-xl font-light">
                    {selectedMember.acquisition || "Bankrupt"}
                  </span>
                </div>
              )}
            </div>
            
            {/* Website button */}
            {selectedMember.website && (
              <a
                href={selectedMember.website}
                target="_blank"
                rel="noopener noreferrer"
                className="self-start h-10 sm:h-12 px-4 sm:px-6 bg-white rounded-3xl inline-flex justify-center items-center gap-2 sm:gap-3 hover:bg-gray-100 transition-colors"
              >
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9999 22.375C17.5227 22.375 22 17.8978 22 12.375C22 6.85224 17.5227 2.375 11.9999 2.375C6.47703 2.375 2 6.85224 2 12.375C2 17.8978 6.47703 22.375 11.9999 22.375Z" stroke="#141B34" strokeWidth="1.875"/>
                  <path d="M11.9999 22.375C14.2091 22.375 16 17.8978 16 12.375C16 6.85224 14.2091 2.375 11.9999 2.375C9.79071 2.375 8 6.85224 8 12.375C8 17.8978 9.79071 22.375 11.9999 22.375Z" stroke="#141B34" strokeWidth="1.875"/>
                  <path d="M2 12.375H22" stroke="#141B34" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span className="text-black text-sm sm:text-base lg:text-xl font-medium">Website</span>
              </a>
            )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
